<section class="newissue-record">
    <span ng-click="toggleDetails()">
        <span class="details-toggle" ng-class="{open:showDetails}"><i class="fa fa-angle-right"></i></span>
        <span c-activity-log-blurb activity="activity"></span>
        <span>{{newIssue}}</span>
    </span>
</section>
<section class="newissue-details" c-toggle="showDetails">
    <section class="recipients-section">
        <span>{{message}}:</span>
    </section>
    <section class="message-section" c-activity-log-message activity="activity"></section>
</section>